export default function SkeletonDiscussion() {
  return (
    <div className="skeleton-discussion">
      <div className="skeleton-header"></div>
      <div className="skeleton-message"></div>
      <div className="skeleton-message short"></div>
      <div className="skeleton-message"></div>
    </div>
  );
}
